import React from "react";
import styles from "../../styles/InfoBlock.module.scss";

const trackingElement = (text) => {
  if (!text) return null;
  if (!text.old && text.new) {
    return <span className={styles.added}>{text.new}</span>;
  }
  if (text.old && text.new && text.old !== text.new) {
    return (
      <div className={styles.replaced}>
        <div className={styles.removed}>{text.old}</div>
        <div className={styles.added}> {text.new}</div>
      </div>
    );
  }
  if (text.old && text.new === "") {
    return <span className={styles.removed}>{text.old}</span>;
  }
  if (!text.old && !text.new) {
    return null;
  }
  return <span className={styles.original}>{text.old}</span>;
};
export default trackingElement;
